import { UserRoleEnum } from "generated/api";

export const EDITABLE_BY_ROLES = {
  everyone: 'Everyone',
  staff: 'Staff Only',
} as const

type EditableByRole = typeof EDITABLE_BY_ROLES[keyof typeof EDITABLE_BY_ROLES]

export function isEditableBy(editable_role: EditableByRole | undefined, role: UserRoleEnum) {
  editable_role = editable_role || EDITABLE_BY_ROLES.everyone
  if (role === 'patient') {
    return editable_role === EDITABLE_BY_ROLES.everyone
  }
  return true
}